/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e } from "../../core/maybe.js";

function t(t, l) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!window.WebGLRenderingContext) return o(t, n), null;
  var b = r(t, l, a);
  return e(b) && o(t, i), b;
}

function r(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var o = 1 === t ? ["webgl", "experimental-webgl", "webkit-3d", "moz-webgl"] : ["webgl2"];
  var n = null;

  for (var _i = 0, _o = o; _i < _o.length; _i++) {
    var l = _o[_i];

    try {
      n = e.getContext(l, r);
    } catch (i) {}

    if (n) break;
  }

  return n;
}

function o(e, t) {
  var r = e.parentNode;
  r && (r.innerHTML = '<table style="background-color: #8CE; width: 100%; height: 100%;"><tr><td align="center"><div style="display: table-cell; vertical-align: middle;"><div style="">' + t + "</div></div></td></tr></table>");
}

var n = 'This page requires a browser that supports WebGL.<br/><a href="http://get.webgl.org">Click here to upgrade your browser.</a>',
    i = 'It doesn\'t appear your computer can support WebGL.<br/><a href="http://get.webgl.org/troubleshooting/">Click here for more information.</a>';
export { r as createContext, t as createContextOrErrorHTML };